export default __webpack_public_path__ + "static/media/Freddy.7c62982f.jpg";